import type { FilterSection } from "@/types/filterTypes";
    
export const useEventsFilterSections = (): FilterSection[] => {

  return [
    {
      key: "searchBy",
      label: "Search",
      type: "text",
    },
    {
      key: "location",
      label: "Location",
      type: "text",
    },
    {
      key: "upcoming",
      label: "Is Upcoming?",
      type: "boolean",
    },
    {
      key: "past",
      label: "Is Past?",
      type: "boolean",
    },

    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "eventStartDateStart",
      label: "Event Start Date Start",
      type: "date",
      placeholder: "From"
    },
    {
      key: "eventStartDateEnd",
      label: "Event Start Date End",
      type: "date",
      placeholder: "To"
    }
  ];
};
